<template>
  <v-navigation-drawer app mobile-break-point="$vuetify.breakpoint.sm">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title">
          {{ storename }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        @click="clickMenu(item)"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("adminMenu." + item.type) }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import Firebase from "firebase";
export default {
  data: function() {
    return {
      items: [
        { type: "home", icon: "home", url: "/admin/home" },
        {
          type: "account",
          icon: "account_box",
          url: "/admin/memberList"
        },
        {
          type: "schedule",
          icon: "calendar_today",
          url: "/admin/schedulelist"
        },
        {
          type: "training",
          icon: "sports_mma",
          url: "/admin/traininglist"
        },
        {
          type: "info",
          icon: "computer",
          url: "/admin/eventlist"
        },
        {
          type: "upload",
          icon: "mdi-arrow-up-bold-box-outline",
          url: "/admin/fileupload"
        },
        {
          type: "type",
          icon: "create",
          url: "/admin/typelist"
        },
        {
          type: "logout",
          icon: "exit_to_app",
          url: "/admin/logout"
        }
      ]
    };
  },
  beforeCreate: function() {
    this.storename = process.env.VUE_APP_STORE_NAME || "Crossfit Admin";
  },
  methods: {
    clickMenu: async function(item) {
      if (item.type === "logout") {
        await Firebase.auth()
          .signOut()
          .then(() => {
            this.$store.dispatch(
              "loginStore/loginInfo/loginInfoStore/setUserInfo",
              null
            );
            this.$store.dispatch(
              "loginStore/loginInfo/loginInfoStore/setSignedIn",
              false
            );
            this.setNextRoot(item);
          });
      } else {
        this.setNextRoot(item);
      }
    },
    logout: async function() {
      this.$store.dispatch(
        "loginStore/loginInfo/loginInfoStore/setUserInfo",
        null
      );
      this.$store.dispatch(
        "loginStore/loginInfo/loginInfoStore/setSignedIn",
        false
      );
    },
    setNextRoot: async function(item) {
      this.$router.push({ path: item.url });
    }
  }
};
</script>
